import { E_MenuType, IUserMenu } from '@/api/moudules/system.types'
import _ from 'lodash'
import Vue from 'vue'
import { E_MenuItem } from './menu'
import { JJIconType } from '@/components/Icons/types'

export interface IMenuItem {
    title: any
    disabled?: boolean
    children?: IMenuItem[]
    router?: string
    isActive?: boolean
    permission?: string
    isCompanyAdminMenu?: boolean
}

export interface IMenuItemEx extends IMenuItem {
    hasChildren: boolean
}

export interface IMenuItemTop extends IMenuItem {
    id?: string
    icon?: string
    icon_active?: string
    faIcon?: JJIconType
    isSuperAdminMenu?: boolean
}

function flattenMenus(vm: Vue, menus: IMenuItem[]): IMenuItem[] {
    return _.flatMap(menus, menu => {
        let {
            title,
            children,
            ...reset
        } = menu
        if (_.has(E_MenuItem, title)) {
            title = vm.$enumTrans.MenuItem(title) as string
        }
        return [{
            title,
            ...reset,
        }, ...flattenMenus(vm, children)]
    })
}

function mapFixedMenuFromSysMenus(sysMenus: IUserMenu[], fixedMenuDict: Record<string, IMenuItem>): IMenuItem[] {
    return _.flatMap(sysMenus, sMenu => {
        if (sMenu.menuType === E_MenuType.Button) {
            return []
        }
        let children = mapFixedMenuFromSysMenus(sMenu.children, fixedMenuDict)
        // 兼容单个菜单如在线监测, 只有一个菜单和主菜单相同
        if (_.size(children) === 1) {
            let firstMenu = children[0]
            if (_.isEmpty(firstMenu.children)) {
                if (firstMenu.permission == sMenu.perms) {
                    children = []
                }
            }
        }
        let localMenu = fixedMenuDict[sMenu.perms]
        if (!localMenu) {
            return []
        }
        return [{
            ...localMenu,
            children,
        }]
    })
}

export function filterPermissionMenus(vm: Vue, menus: IMenuItem[], sysMenus: IUserMenu[]) {
    let fixedMenu = flattenMenus(vm, menus)
    let fixedMenuDict = _.fromPairs(_.map(fixedMenu, m => [m.permission, m]))
    return mapFixedMenuFromSysMenus(sysMenus, fixedMenuDict)
}

function loopCollectRoutes(menu: IMenuItem, collector: string[]) {
    if (menu.router) {
        collector.push(menu.router)
    }
    if (menu.children) {
        _.each(menu.children, submenu => {
            loopCollectRoutes(submenu, collector)
        })
    }
}

export function collectSubRoutes(menu: IMenuItem) {
    let routes = []
    loopCollectRoutes(menu, routes)
    return new Set(routes)
}

export function hasChildren(menu: IMenuItem) {
    return !_.isEmpty(menu.children)
}
